import React from 'react';
import RBModal from 'react-bootstrap/Modal';

// import './Modal.css';

const Modal = ({ show, onHide, children }) => {
  return (
    <RBModal show={show} onHide={onHide} dialogClassName="modal-custom">
      <RBModal.Body>{children}</RBModal.Body>
    </RBModal>
  );
};

export default Modal;
